/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterUserDto } from '../../models/center-user-dto';

export interface CenterUserControllerFindById$Params {

/**
 * 센터 구성원 ID
 */
  id: string;
}

export function centerUserControllerFindById(http: HttpClient, rootUrl: string, params: CenterUserControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterUserDto>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterUserDto>;
    })
  );
}

centerUserControllerFindById.PATH = '/api/center-user/{id}';
